'use client';
import { memo } from 'react';
import { Box } from '@chakra-ui/react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Mousewheel, Grid, Autoplay, Navigation, Controller } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import 'swiper/css/grid';
import './model/sliderStyles.scss';

const Slider = ({
  swiperRef = null,
  slidesData,
  SlideComponent,
  slideStyle = null,
  sameStyles = null,
  isBreakpoints = true,
  type = '',
  controller = null,
  setController = null,
  container = {},
  ...props
}) => (
  <Box w="full" className={`box-swiper ${type}`} {...container}>
    <Swiper
      onSwiper={swiper => {
        if (swiperRef) swiperRef.current = swiper;
        setController && setController(swiper);
      }}
      spaceBetween="20px"
      grabCursor={true}
      freeMode={true}
      mousewheel={true}
      slidesPerView={1}
      touchReleaseOnEdges
      controller={{ control: controller }}
      pagination={{ clickable: true }}
      breakpoints={isBreakpoints && { 656: { slidesPerView: 'auto' } }}
      modules={[Grid, Autoplay, Pagination, Mousewheel, Navigation, Controller]}
      {...props}
    >
      {slidesData?.map((val, index) => {
        let style;
        if (typeof slideStyle === 'function') {
          style = slideStyle(index);
        } else if (typeof slideStyle === 'object') {
          style = slideStyle?.[index];
        }
        return (
          <SwiperSlide key={`swiperSlide-${index}`} style={{ zIndex: slidesData.length - index }}>
            <SlideComponent {...val} {...(sameStyles ? sameStyles : style)} />
          </SwiperSlide>
        );
      })}
    </Swiper>
  </Box>
);

export default memo(Slider);
